<template>
  <div class="flex pointer-events-all relative">
    <div
      class="flex flex-col items-center mr-2"
      v-if="device?.config && showCameraInfo"
    >
      <TelemetreLaser_btn :config="device?.config" />
      <!-- Camera|Photo Mode -->
      <Mode_Switch
        :config="device?.config"
        v-if="device?.config?.camera?.payloadAsSelected"
      />
      <!-- Lens -->
      <Lens :config="device?.config && video != false" :video="video" />
      <!-- Resolution -->
      <Resolution :config="device?.config && video != false" :video="video" />
    </div>

    <template v-if="device?.config">
      <div class="flex flex-col">
        <div
          class="bg-g1 flex justify-between px-3 py-1 w-full mb-2"
          v-if="device?.config"
        >
          <DroneElevation :config="device?.config" />
          <DroneHSpeed :config="device?.config" />
          <DroneVSpeed :config="device?.config" />
          <DroneHomeDistance :config="device?.config" />
          <DroneWindSpeed :config="device?.config" />
          <div
            class="text-[11px] flex items-center"
            v-if="device?.config?.openTelemetreLaser"
          >
            <SVG name="telemetreLaser" class="w-[16px] fill-current"></SVG> : 
            <TelemetreLaser_affichage
              :config="device?.config"
              :noClass="true"
            />
          </div>
        </div>
        <div class="flex">
          <div class="bg-g0 px-3 pt-4 flex">
            <Flight_ControlePanel
              v-if="device?.config?.dock?.status?.drc_state === 2"
              :config="device?.config"
            />
            <div class="px-0.5"></div>
            <Flight_Action :config="device?.config" />
          </div>
        </div>
      </div>
    </template>
    <div class="flex items-center ml-2" v-if="device?.config && showCameraInfo">
      <div class="mr-2">
        <Zoom :config="device?.config" :video="video" />
      </div>
      <Mode_Photo
        :config="device?.config"
        :video="video"
        v-if="device?.config?.camera?.payloadAsSelected"
      />
      <Mode_Camera
        :config="device?.config"
        :video="video"
        v-if="device?.config?.camera?.payloadAsSelected"
      />
      <Mode_Remain :config="device?.config" :video="video" />
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import SVG from "@/partials/SVG.vue";

import DroneHSpeed from "@/partials/Device/Template/Drone/DroneHSpeed.vue";
import DroneVSpeed from "@/partials/Device/Template/Drone/DroneVSpeed.vue";
import DroneHomeDistance from "@/partials/Device/Template/Drone/DroneHomeDistance.vue";
import DroneElevation from "@/partials/Device/Template/Drone/DroneElevation.vue";
import DroneWindSpeed from "@/partials/Device/Template/Drone/DroneWindSpeed.vue";

import TelemetreLaser_btn from "@/partials/Video/Camera/Options/TelemetreLaser/TelemetreLaser_btn.vue";
import TelemetreLaser_affichage from "@/partials/Video/Camera/Options/TelemetreLaser/TelemetreLaser_affichage.vue";
import Mode_Switch from "@/partials/Video/Camera/Options/Mode/Mode_Switch.vue";
import Lens from "@/partials/Video/Camera/Options/Lens.vue";
import Resolution from "@/partials/Video/Camera/Options/Resolution.vue";

import Mode_Remain from "@/partials/Video/Camera/Options/Mode/Mode_Remain.vue";
import Mode_Photo from "@/partials/Video/Camera/Options/Mode/Mode_Photo.vue";
import Mode_Camera from "@/partials/Video/Camera/Options/Mode/Mode_Camera.vue";
import Zoom from "@/partials/Video/Camera/Options/Zoom.vue";

import Flight_ControlePanel from "@/partials/Device/Template/Flight/Flight_ControlePanel.vue";
import Flight_Action from "@/app/popup/partial/Flight_Action.vue";

export default {
  name: "App_Popup",
  components: {
    SVG,
    DroneHSpeed,
    DroneVSpeed,
    DroneHomeDistance,
    DroneWindSpeed,
    DroneElevation,
    TelemetreLaser_btn,
    TelemetreLaser_affichage,
    Mode_Switch,
    Lens,
    Resolution,
    Flight_ControlePanel,
    Flight_Action,
    Mode_Remain,
    Mode_Photo,
    Mode_Camera,
    Zoom,
  },
  props: {
    device: Object,
    VIDEO_EMPLACEMENT: Object,
  },
  setup() {
    return {
      video: ref(false),
    };
  },

  mounted() {
    this.device.config.videos.forEach((item) => {
      if (item.dvv_text === "Nacelle") {
        this.video = item;
      }
    });
  },

  computed: {
    showCameraInfo() {
      if (this.video == false) {
        return false;
      }

      let keys = Object.keys(this.VIDEO_EMPLACEMENT);
      let camera = false;

      keys.forEach((key) => {
        if (this.VIDEO_EMPLACEMENT[key] === "#FRONT") {
          camera = key;
        }
      });

      if (camera == false) {
        return true;
      }

      return !(this.video.dvv_id == camera);
    },
  },
};
</script>
